"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentItemThumbnail = void 0;

var _react = _interopRequireDefault(require("react"));

var _Layout = require("../../atoms/Layout");

var _Icon = require("../../atoms/Icon");

var _Icons = require("../../atoms/Icons");

var _constants = require("./constants");

var _styles = require("./styles");

var ContentItemThumbnailPreview = function ContentItemThumbnailPreview(_ref) {
  var type = _ref.type,
      id = _ref.id,
      description = _ref.description,
      url = _ref.url;

  if (url && type === 'image') {
    return _react.default.createElement(_styles.ContentItemThumbnailPreviewImageStyled, {
      src: url,
      alt: description,
      fixed: {
        width: 40,
        height: 40
      },
      draggable: "false"
    });
  }

  var icon = _react.default.createElement(_Icons.FontHeavy, null);

  if (type === 's3image' || type === 'image') {
    icon = _react.default.createElement(_Icons.ImageHeavy, null);
  }

  if (type === 'embed') {
    icon = _react.default.createElement(_Icons.PlayCircleHeavy, null);
  }

  return _react.default.createElement(_Layout.Box, {
    key: "".concat(id, "-").concat(type),
    padding: 3,
    backgroundColor: "guama"
  }, _react.default.createElement(_Icon.Icon, {
    size: "tiny",
    color: "coco"
  }, icon));
};

ContentItemThumbnailPreview.defaultProps = {
  type: 'text',
  url: null
};

var ContentItemThumbnail = function ContentItemThumbnail(_ref2) {
  var item = _ref2.item,
      withTopBorder = _ref2.withTopBorder,
      withBottomBorder = _ref2.withBottomBorder;
  var description = item.description,
      id = item.id,
      type = item.type,
      url = item.url;
  return _react.default.createElement(_Layout.Flex, {
    backgroundColor: "copoazu",
    width: ['307px', '307px', '375px'],
    height: _constants.CONTENT_ITEM_THUMBNAIL_HEIGHT,
    borderWidth: 0,
    borderTopWidth: withTopBorder ? 1 : 0,
    borderBottomWidth: withBottomBorder ? 1 : 0,
    borderStyle: "solid",
    borderColor: "guama"
  }, _react.default.createElement(_styles.ContentItemThumbnailHamburgerStyled, {
    padding: [5],
    borderColor: "guama"
  }, _react.default.createElement(_Icon.Icon, {
    size: "tiny",
    color: "guama"
  }, _react.default.createElement(_Icons.MenuHeavy, null))), _react.default.createElement(_Layout.Flex, {
    position: "relative",
    right: 0,
    top: 0,
    padding: 3
  }, _react.default.createElement(ContentItemThumbnailPreview, {
    type: type,
    id: id,
    url: url,
    description: description
  }), _react.default.createElement(_Layout.Box, {
    key: "".concat(id, "-").concat(type, "-description"),
    paddingLeft: 3,
    paddingTop: 2
  }, _react.default.createElement(_styles.TextStyled, {
    color: "guijarro",
    width: ['158px', '158px', '228px']
  }, description))));
};

exports.ContentItemThumbnail = ContentItemThumbnail;
ContentItemThumbnail.defaultProps = {
  withTopBorder: false,
  withBottomBorder: true
};